import { useCallback, useState } from 'react'

type Session = {
  date: string
  trainingNumber?: number
  episodeNumber?: number
}

type Sessions = {
  training: Session[]
  course: Session[]
  totalWeekendSessions: number
}

function sortSessions(sessionsList: Session[]) {
  return [...sessionsList].sort((a, b) => {
    const dateA = new Date(a.date)
    const dateB = new Date(b.date)

    dateA.setHours(0, 0, 0, 0)
    dateB.setHours(0, 0, 0, 0)

    const dateComparison = dateA.getTime() - dateB.getTime()

    if (dateComparison === 0) {
      const numA = a.trainingNumber ?? a.episodeNumber ?? 0
      const numB = b.trainingNumber ?? b.episodeNumber ?? 0
      return numA - numB
    }

    return dateComparison
  })
}

function useSessions(initialSessions: Sessions | null) {
  const [sessions, setSessions] = useState<Sessions | null>(initialSessions)

  const setTrainingSessions = useCallback((trainingList: Session[]) => {
    setSessions((prev) => ({
      ...prev,
      training: trainingList
    }))
  }, [])

  const setCourseSessions = useCallback((courseList: Session[]) => {
    setSessions((prev) => ({
      ...prev,
      course: courseList
    }))
  }, [])

  const setAllSessions = useCallback((fullSessions: Sessions) => {
    setSessions({
      totalWeekendSessions: fullSessions.totalWeekendSessions,
      training: sortSessions(fullSessions.training),
      course: sortSessions(fullSessions.course)
    })
  }, [])

  return {
    sessions,
    setAllSessions,
    setTrainingSessions,
    setCourseSessions
  }
}

export default useSessions
